import { __assign } from "tslib";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './dropdown-select.module.css';
import { noResultsItems } from '../dropdowns.helpers';
import { ArrowIcon, ChevronIcon } from '../../../../design';
export var DropdownSelect = React.forwardRef(function (props, outerRef) {
    var _a;
    var _b;
    var 
    // html props
    id = props.id, name = props.name, disabled = props.disabled, onChange = props.onChange, 
    // custom props
    label = props.label, items = props.items, validation = props.validation, large = props.large, responsive = props.responsive;
    var cleansedProps = __assign(__assign({}, props), { 
        // html props
        id: id !== null && id !== void 0 ? id : label, name: name !== null && name !== void 0 ? name : label, disabled: disabled, 
        // custom props
        label: undefined, items: undefined, validation: undefined, large: undefined, responsive: undefined });
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var _c = useState(noResultsItems), currentItems = _c[0], setCurrentItems = _c[1];
    var _d = useState(currentItems.find(function (item) { return item.selected; })), selectedItem = _d[0], setSelectedItem = _d[1];
    useEffect(function () {
        var nextItems = items.length === 0 ? noResultsItems : items.map(function (item) { return (__assign({}, item)); });
        setCurrentItems(nextItems);
        setSelectedItem(nextItems.find(function (item) { return item.selected; }));
    }, [items]);
    useEffect(function () {
        var _a, _b;
        if (!!props.value)
            return (_a = items.find(function (item) { return item.value === props.value; })) === null || _a === void 0 ? void 0 : _a.onClick();
        if (!!props.defaultValue)
            return (_b = items.find(function (item) { return item.value === props.defaultValue; })) === null || _b === void 0 ? void 0 : _b.onClick();
    }, [props.defaultValue, props.value]);
    function onChangeHandler(event) {
        // TODO: look at change detection in cohesion with FieldController
        var item = currentItems.find(function (temp) { return temp.value === event.target.value; });
        if (!item)
            return;
        item.onClick();
        if (!!onChange)
            onChange(event);
    }
    return (React.createElement("div", { className: classNames('fieldValidationWrapper', { responsive: responsive }) },
        React.createElement("div", { className: classNames('inputWrapper', {
                populated: !!selectedItem,
                validation: (validation === null || validation === void 0 ? void 0 : validation.dirty) && (validation === null || validation === void 0 ? void 0 : validation.invalid),
                disabled: disabled,
                large: large,
                responsive: responsive,
            }) },
            React.createElement("label", { htmlFor: id !== null && id !== void 0 ? id : label, className: "inputLabel inputText" }, label),
            React.createElement("select", __assign({}, cleansedProps, { ref: innerRef, className: classNames('inputTriggerWrapper inputTrigger inputText', styles.dropdownSelectTrigger, (_a = {}, _a[styles.populated] = !!selectedItem, _a)), onChange: onChangeHandler, value: (_b = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) !== null && _b !== void 0 ? _b : '' }),
                !selectedItem && (React.createElement("option", { className: "dropdownOptionV2", value: "", disabled: true, hidden: true }, "Select an option")),
                currentItems.map(function (item) {
                    var _a;
                    return (React.createElement("option", { key: item.value, className: classNames('inputText', [styles.dropdownSelectOption]), value: item.value, disabled: item.disabled }, (_a = item.label) !== null && _a !== void 0 ? _a : item.value));
                })),
            React.createElement("div", { className: "inputIcon suffix" }, large ? (React.createElement(ChevronIcon, { tone: disabled ? 'default' : 'primary', rotation: 2 })) : (React.createElement(ArrowIcon, { tone: disabled ? 'default' : 'primary' })))),
        !!validation && (React.createElement("div", { className: classNames('fieldValidation fieldErrorMessage', { invisible: !validation.dirty || !validation.invalid }) }, validation.message))));
});
DropdownSelect.displayName = 'DropdownSelect';
export default DropdownSelect;
